(function () {
hubspot.define('hubspot.embedding.host', ['q/js/lib/defer', 'q/js/lib/delay', 'hubspot.embedding.common'], function(defer, delay, embed) {
  var callerQueue, respondToAppMessages, startApp, startPollingForApp, waitForAppReady;
  callerQueue = {};
  startPollingForApp = function() {
    var callerInfos;
    callerInfos = _.values(callerQueue);
    if (callerInfos.length === 0) {
      return;
    }
    _.each(callerInfos, function(callerInfo) {
      var message;
      if (callerInfo.appStartFulfilled) {
        return;
      }
      message = {
        targetWindow: callerInfo.targetWindow,
        channel: callerInfo.channel,
        destination: callerInfo.appOrigin,
        origin: embed.getOrigin(),
        data: {
          command: embed.APP_HOSTID
        }
      };
      return embed.sendMessageTo(message);
    });
    return delay(50).then(startPollingForApp);
  };
  respondToAppMessages = function(message, origin, sourceWindow) {
    var callerInfo, deferred;
    callerInfo = callerQueue[message.channel];
    if (callerInfo && (message.data != null)) {
      if (message.data.command === embed.APP_READY) {
        deferred = callerInfo.deferreds.appStart;
      } else if (message.data.command === embed.APP_DONE) {
        deferred = callerInfo.deferreds.appDone;
        embed.stopListeningTo(message.channel);
        delete callerQueue[message.channel];
      } else if (callerInfo.deferreds.appLifetime) {
        callerInfo.deferreds.appLifetime.notify(message);
      }
      return deferred != null ? deferred.resolve({
        message: message,
        origin: origin,
        sourceWindow: sourceWindow
      }) : void 0;
    }
  };
  waitForAppReady = function(arg) {
    var appDoneDeferred, appLifetime, appStartDeferred, callerInfo, channel, fulfillAppStart, origin, targetWindow;
    origin = arg.origin, channel = arg.channel, targetWindow = arg.targetWindow, appLifetime = arg.appLifetime;
    appStartDeferred = defer();
    appDoneDeferred = defer();
    callerInfo = {
      deferreds: {
        appStart: appStartDeferred,
        appDone: appDoneDeferred
      },
      promises: {
        appStart: appStartDeferred.promise,
        appDone: appDoneDeferred.promise
      },
      appStartFulfilled: false,
      targetWindow: targetWindow,
      appOrigin: origin,
      channel: channel
    };
    callerQueue[channel] = callerInfo;
    fulfillAppStart = function() {
      callerInfo.appStartFulfilled = true;
    };
    appStartDeferred.promise.then(fulfillAppStart, fulfillAppStart);
    if (appLifetime) {
      callerInfo.deferreds.appLifetime = appLifetime;
    }
    embed.listenTo({
      origin: origin,
      channel: channel,
      handler: respondToAppMessages
    });
    startPollingForApp();
    return appStartDeferred.promise;
  };
  startApp = function(arg) {
    var callerInfo, channel, params;
    channel = arg.channel, params = arg.params;
    callerInfo = callerQueue[channel];
    embed.sendMessageTo({
      channel: channel,
      destination: callerInfo.appOrigin,
      targetWindow: callerInfo.targetWindow,
      origin: embed.getOrigin(),
      data: {
        command: embed.APP_PARAMS,
        params: params
      }
    });
    return callerInfo.promises.appDone;
  };
  return {
    waitForAppReady: waitForAppReady,
    startApp: startApp
  };
});
}());

